import { apiClient } from "@/lib/apiClient";
import {
  CreateTaxDto,
  UpdateTaxDto,
  FetchTaxesOptions,
} from "@/types/models/tax";

// Tax CRUD Operations
export const getTaxes = async (options: FetchTaxesOptions = {}) => {
  const params: Record<string, string> = {};

  if (options.page) params.page = options.page.toString();
  if (options.page_size) params.page_size = options.page_size.toString();
  if (options.sort_by) params.sort_by = options.sort_by;
  if (options.sort_order) params.sort_order = options.sort_order;

  return await apiClient.getPaginated("/api/v1/admin/:storeId/taxes", params);
};

export const getTaxById = async (id: string): Promise<any> => {
  return await apiClient.get(`/api/v1/admin/:storeId/taxes/${id}`);
};

export const createTax = async (data: CreateTaxDto): Promise<any> => {
  return await apiClient.post("/api/v1/admin/:storeId/taxes", data);
};

export const updateTax = async (
  id: string,
  data: UpdateTaxDto,
): Promise<any> => {
  return await apiClient.put(`/api/v1/admin/:storeId/taxes/${id}`, data);
};

export const deleteTax = async (id: string): Promise<any> => {
  return await apiClient.delete(`/api/v1/admin/:storeId/taxes/${id}`);
};

// Search taxes
export const searchTaxes = async (
  query: string,
  options: FetchTaxesOptions = {},
) => {
  const params: Record<string, string> = {
    search: query,
  };

  if (options.page) params.page = options.page.toString();
  if (options.page_size) params.page_size = options.page_size.toString();
  if (options.sort_by) params.sort_by = options.sort_by;
  if (options.sort_order) params.sort_order = options.sort_order;

  return await apiClient.getPaginated("/api/v1/admin/:storeId/taxes", params);
};
